import { Dayjs } from "dayjs"
import { IUserCancellation } from "./userCancellation.types"

export class UserCancellation implements IUserCancellation {
  constructor(
    public id: number,
    public createdAt: Dayjs,
  ) {}
}
